(function () {
  'use strict'
  imageError.$inject = []
  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Directives')
    .directive('imgError', imageError)
  function imageError () {
    return {
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          if (attrs.src !== attrs.imgError) {
            attrs.$set('src', attrs.imgError)
          }
        })
      }
    }
  }
// eslint-disable-next-line semi
})();
